'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validator2 = require('./Validator');

var _Validator3 = _interopRequireDefault(_Validator2);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlValidator = function (_Validator) {
  _inherits(UrlValidator, _Validator);

  function UrlValidator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        message = _ref.message,
        _ref$schemes = _ref.schemes,
        schemes = _ref$schemes === undefined ? ['http', 'https'] : _ref$schemes,
        _ref$allowLocal = _ref.allowLocal,
        allowLocal = _ref$allowLocal === undefined ? false : _ref$allowLocal;

    _classCallCheck(this, UrlValidator);

    var _this = _possibleConstructorReturn(this, (UrlValidator.__proto__ || Object.getPrototypeOf(UrlValidator)).call(this));

    _this.message = message;
    _this.schemes = schemes;
    _this.allowLocal = allowLocal;
    return _this;
  }

  _createClass(UrlValidator, [{
    key: 'validate',
    value: function validate(value, attribute) {
      // Empty values are fine
      if (!_utils2.default.isDefined(value) || _utils2.default.isEmpty(value)) {
        return Promise.resolve();
      }

      if (!_utils2.default.isString(value)) {
        return Promise.reject(this.createMessage(this.message || UrlValidator.MESSAGE, {
          attribute: attribute
        }));
      }

      // https://gist.github.com/dperini/729294
      var regex = '' + ('^' +
      // protocol identifier
      '(?:(?:') + this.schemes.join('|') + ')://)' +
      // user:pass authentication
      '(?:\\S+(?::\\S*)?@)?' + '(?:';

      var tld = '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))';

      if (this.allowLocal) {
        tld += '?';
      } else {
        regex +=
        // IP address exclusion
        // private & local networks
        '(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})';
      }

      regex +=
      // IP address dotted notation octets
      // excludes loopback network 0.0.0.0
      // excludes reserved space >= 224.0.0.0
      // excludes network & broacast addresses
      // (first & last IP address of each class)
      '' + ('(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' +
      // host name
      '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
      // domain name
      '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*') + tld + ')' +
      // port number
      '(?::\\d{2,5})?' +
      // resource path
      '(?:[/?#]\\S*)?' + '$';

      var PATTERN = new RegExp(regex, 'i');

      if (!PATTERN.exec(value)) {
        return Promise.reject(this.createMessage(this.message || UrlValidator.MESSAGE, {
          attribute: attribute
        }));
      }

      return Promise.resolve();
    }
  }]);

  return UrlValidator;
}(_Validator3.default);

UrlValidator.MESSAGE = '{attribute} - is not a valid url';
exports.default = UrlValidator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/UrlValidator.js
// module id = 776
// module chunks = 0